import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

export const loginSlice = createSlice({
    name: "login",
    initialState: {
        data: {}
    },
    reducers: {
        logueo: (state, action) => {
            state.data = action.payload
        }
    }
});


///Async calls
export const getUsersAsync = (usuario, pass) => async (dispatch) => {
    /* const res = await axios.post('http://localhost/qa.lumen/api/login',null,{
        params:{
            email:usuario,
            password:pass
        }
    });
    //window.localStorage.setItem('usuario', JSON.stringify(res.data));
    //console.log("respuesta",res); */
    var data = JSON.stringify({
        "email": usuario,
        "password": pass
    });

    var config = {
        method: 'post',
        url:`${process.env.URLAPI}login`,
        //url: 'http://localhost/qa.lumen/api/login',
        //url: 'https://api.ticc.com.mx/api/login',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    const res = await axios(config)
        .then(function (response) {
            return response;
            //console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
            console.log(error);
        });
    dispatch(logueo(res.data));
};

export const selectStateLogin = (state) => state.login.data;

//Acciones
export const { logueo, loading } = loginSlice.actions;

//Reducer
export default loginSlice.reducer;